export const TICKET_STORAGE_KEY = 'social_collage_ticket';

export const DEFAULT_EXPIRED_TICKET_MESSAGE =
  'This ticket has expired. Please purchase a new ticket.';

export const DEFAULT_INVALID_MESSAGE = 'Invalid ticket. Check ticket date & time.';

export const getTicketIdFromScan = (decodedText) => {
  const value = String(decodedText || '').trim();
  if (!value) return '';

  try {
    const scannedUrl = new URL(value);
    return scannedUrl.searchParams.get('ticketId') || value;
  } catch {
    return value;
  }
};

export const getExtendTicketUrl = (ticketId) => {
  const webUrl = process.env.REACT_APP_FRONTEND_BASE_URL?.trim();
  if (!webUrl || !ticketId) return '';

  try {
    const extendUrl = new URL('/extend-ticket', webUrl);
    extendUrl.searchParams.set('ticketId', ticketId);
    return extendUrl.toString();
  } catch {
    return '';
  }
};

export const pickTicket = (data = {}) => {
  if (data.ticket && typeof data.ticket === 'object' && data.ticket.id) {
    return data.ticket;
  }
  if (data.id) return data;
  return null;
};

export const isTicketExpired = (data = {}) =>
  data.isExpired === true ||
  data.ticket?.ticket_status?.toLowerCase() === 'expired' ||
  data.ticketStatus?.toLowerCase() === 'expired';

export const isTicketExtendable = (data = {}) =>
  data.isExtendable === true || data.canExtend === true;

export const ticketRecordNames = (ticket) => {
  const records = [];
  if (ticket?.ticket && typeof ticket.ticket === 'object') records.push(ticket.ticket);
  if (ticket && typeof ticket === 'object') records.push(ticket);

  const read = (keys) =>
    records
      .map((record) => keys.map((key) => String(record?.[key] || '').trim()).find(Boolean) || '')
      .find(Boolean) || '';

  const firstName = read(['first_name', 'firstName']);
  const lastName = read(['last_name', 'lastName']);
  return {
    firstName,
    lastName,
    fullName: [firstName, lastName].filter(Boolean).join(' '),
    isEmpty: !firstName && !lastName,
  };
};

export const splitGuestName = (fullName) => {
  const parts = String(fullName || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  return {
    firstName: parts[0] || '',
    lastName: parts.length > 1 ? parts.slice(1).join(' ') : '',
  };
};

export const mergeTicketNames = (ticket = {}, names = {}) => {
  const firstName = String(names.firstName || '').trim();
  const lastName = String(names.lastName || '').trim();
  const named = {
    firstName,
    lastName,
    first_name: firstName,
    last_name: lastName,
  };
  const nested =
    ticket?.ticket && typeof ticket.ticket === 'object'
      ? { ...ticket.ticket, ...named }
      : ticket?.ticket;

  return {
    ...ticket,
    ...named,
    ...(nested ? { ticket: nested } : {}),
  };
};

export const saveTicket = (ticket) => {
  if (!ticket) return;
  try {
    sessionStorage.setItem(TICKET_STORAGE_KEY, JSON.stringify(ticket));
  } catch {
    /* ignore */
  }
};

export const readTicket = () => {
  try {
    const raw = sessionStorage.getItem(TICKET_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearTicket = () => {
  try {
    sessionStorage.removeItem(TICKET_STORAGE_KEY);
  } catch {
    /* ignore */
  }
};
